import React from 'react'
import { defPath } from '../../config/defPath'
import { type CartProduct, useCartStore } from '../../hooks/useCartStore'

export const ShopingCartItem = ({ data }: { data: CartProduct }) => {
    const updateQuantity = useCartStore(state => state.updateQuantity)
    const removeFromCart = useCartStore(state => state.removeFromCart)

    const handleIncrease = () => {
        updateQuantity(data.sku, data.quantity + 1)
    }
    const handleDecrease = () => {
        if (data.quantity === 1) {
            removeFromCart(data.sku)
        } else {
            updateQuantity(data.sku, data.quantity - 1)
        }
    }

    const priceTotal = (Number(data.precio) * data.quantity).toLocaleString('es-CO')

    return (
        <div className="ar__shoppingCart__item" >
            <div className="ar__shoppingCart__item__img">
                <img src={data.img} alt={data.name} />
            </div>
            <div className="ar__shoppingCart__item__info">
                <h2 className="ar__shoppingCart__item__info__title">{data.name}</h2>
                <p className="ar__shoppingCart__item__info__desc">{data.descr}</p>
                <div className="ar__shoppingCart__item__counter">
                    <button className="ar__shoppingCart__item__counter__btn" onClick={handleDecrease}>-</button>
                    <span className="ar__shoppingCart__item__counter__number">{data.quantity}</span>
                    <button className="ar__shoppingCart__item__counter__btn" onClick={handleIncrease}>+</button>
                </div>
            </div>
            <div className="ar__shoppingCart__item__price">$ {priceTotal}</div>
        </div>
    )
}